<div class="case-detail-page">
  <div class="container-fluid">
    <div class="case-detail-card">

      <a href="javascript:void(0)" class="back-link" (click)="backToCaseList()">
        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back to Cases Shared
      </a>

      <!-- Loading -->
      <div class="loading-state" *ngIf="loading">
        <p class="loading-text">Loading case details…</p>
      </div>

      <ng-container *ngIf="!loading && caseData">
        <div class="detail-header">
          <div class="title-row">
            <div class="title-left">
              <h2 class="case-title">{{ caseData.issueTitle }}</h2>
              <!-- <span class="status-badge" [ngClass]="'status-' + caseData.status">{{ statusLabel(caseData.status) }}</span> -->
            </div>
            <button type="button" class="btn-add-notes header-add-notes" (click)="openAddNotes()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add Notes
            </button>
          </div>
          <div class="header-meta-row">
            <p class="header-meta" *ngIf="caseData.sharedByName"><i class="fa fa-user" aria-hidden="true"></i> Shared by: {{ caseData.sharedByName }}</p>
            <p class="header-meta" *ngIf="caseData.updatedAt"><i class="fa fa-clock-o" aria-hidden="true"></i> Shared On: {{ (caseData.updatedAt + 'Z') | date:'MMM d, yyyy, h:mm a':'Asia/Kolkata' }}</p>
          </div>
        </div>

        <!-- Tabs -->
        <div class="detail-tabs" role="tablist">
          <button type="button" class="tab-btn" [class.tab-btn--active]="activeTab === 'overview'"
                  role="tab" [attr.aria-selected]="activeTab === 'overview'"
                  (click)="setTab('overview')">
            Overview
          </button>
          <button type="button" class="tab-btn" [class.tab-btn--active]="activeTab === 'documents'"
                  role="tab" [attr.aria-selected]="activeTab === 'documents'"
                  (click)="setTab('documents')">
            Supporting Documents ({{ documentCount }})
          </button>
          <button type="button" class="tab-btn" [class.tab-btn--active]="activeTab === 'notes'"
                  role="tab" [attr.aria-selected]="activeTab === 'notes'"
                  (click)="setTab('notes')">
          Notes ({{ noteCount }})
          </button>
        </div>

        <!-- Overview tab -->
        <div class="tab-panel" *ngIf="activeTab === 'overview'">
          <div class="overview-grid">

            <!-- Issue Type -->
            <div class="field-card" *ngIf="hasValue(caseData.issueType)">
              <div class="card-header">
                <i class="fa fa-tag card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Issue Type</h4>
              </div>
              <div class="field-block">
                <span class="pill" *ngFor="let t of caseData.issueType">{{ t }}</span>
              </div>
            </div>

            <!-- Opposing Parties -->
            <div class="field-card" *ngIf="hasValue(caseData.opposingParties)">
              <div class="card-header">
                <i class="fa fa-users card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Opposing Parties ({{ caseData.opposingParties?.length || 0 }})</h4>
              </div>
              <div class="party-list">
                <div class="party-row" *ngFor="let p of caseData.opposingParties; let i = index"
                     [class.party-row--expanded]="isPartyExpanded(i)">
                  <!-- Single party: toggle button too, so the user can collapse/expand it; open by default -->
                  <ng-container *ngIf="caseData.opposingParties?.length === 1; else multiParty">
                    <button type="button" class="party-row-header single-party"
                            (click)="toggleSingleParty()"
                            [attr.aria-expanded]="isPartyExpanded(i)"
                            [disabled]="!hasPartyDetails(p)">
                      <span class="party-name">{{ i + 1 }}. {{ getPartyName(p) }}</span>
                      <i class="fa fa-chevron-down party-chevron" aria-hidden="true" *ngIf="hasPartyDetails(p)"></i>
                    </button>
                  </ng-container>
                  <ng-template #multiParty>
                    <button type="button" class="party-row-header" 
                            (click)="togglePartyExpand(i)"
                            [attr.aria-expanded]="isPartyExpanded(i)"
                            [disabled]="!hasPartyDetails(p)">
                      <span class="party-name">{{ i + 1 }}. {{ getPartyName(p) }}</span>
                      <i class="fa fa-chevron-down party-chevron" aria-hidden="true" *ngIf="hasPartyDetails(p)"></i>
                    </button>
                  </ng-template>
                  <div class="party-details" *ngIf="isPartyExpanded(i) && hasPartyDetails(p)">
                    <div class="party-detail-row" *ngIf="getPartyDetail(p, 'phone') || getPartyDetail(p, 'role')">
                      <div class="party-detail-item" *ngIf="getPartyDetail(p, 'phone')">
                        <p class="field-label"><i class="fa fa-phone" aria-hidden="true"></i> Phone</p>
                        <p class="field-value">{{ getPartyDetail(p, 'phone') }}</p>
                      </div>
                      <div class="party-detail-item" *ngIf="getPartyDetail(p, 'role')">
                        <p class="field-label"><i class="fa fa-briefcase" aria-hidden="true"></i> Role/Relationship</p>
                        <p class="field-value">{{ getPartyDetail(p, 'role') }}</p>
                      </div>
                    </div>
                    <div class="party-detail-item" *ngIf="getPartyDetail(p, 'email')">
                      <p class="field-label"><i class="fa fa-envelope" aria-hidden="true"></i> Email</p>
                      <p class="field-value">{{ getPartyDetail(p, 'email') }}</p>
                    </div>
                    <div class="party-detail-item" *ngIf="getPartyDetail(p, 'address')">
                      <p class="field-label"><i class="fa fa-map-marker" aria-hidden="true"></i> Address</p>
                      <p class="field-value">{{ getPartyDetail(p, 'address') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Incident / Background -->
            <div class="field-card" *ngIf="hasValue(caseData.incidentDescription)">
              <div class="card-header">
                <i class="fa fa-exclamation-triangle card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Incident / Background</h4>
              </div>
              <p class="field-value" [class.clamp-text]="isLongText(caseData.incidentDescription) && !isFieldExpanded('incidentDescription')">{{ caseData.incidentDescription }}</p>
              <button type="button" class="read-more-btn" *ngIf="isLongText(caseData.incidentDescription)" (click)="toggleFieldExpanded('incidentDescription')">
                {{ isFieldExpanded('incidentDescription') ? 'Read less' : 'Read more' }}
                <i class="fa" [ngClass]="isFieldExpanded('incidentDescription') ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
              </button>
            </div>

            <!-- Expected Outcome -->
            <div class="field-card" *ngIf="hasValue(caseData.expectedOutcome)">
              <div class="card-header">
                <i class="fa fa-bullseye card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Expected Outcome</h4>
              </div>
              <ul class="bullet-list">
                <li *ngFor="let o of caseData.expectedOutcome"><i class="fa fa-circle" aria-hidden="true"></i> {{ o }}</li>
              </ul>
            </div>

            <!-- Legal Action Taken -->
            <div class="field-card" *ngIf="hasValue(caseData.legalActionTaken)">
              <div class="card-header">
                <i class="fa fa-gavel card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Legal Action Taken</h4>
              </div>
              <p class="field-value" [class.clamp-text]="isLongText(caseData.legalActionTaken) && !isFieldExpanded('legalActionTaken')">{{ caseData.legalActionTaken }}</p>
              <button type="button" class="read-more-btn" *ngIf="isLongText(caseData.legalActionTaken)" (click)="toggleFieldExpanded('legalActionTaken')">
                {{ isFieldExpanded('legalActionTaken') ? 'Read less' : 'Read more' }}
                <i class="fa" [ngClass]="isFieldExpanded('legalActionTaken') ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
              </button>
            </div>

            <!-- Key Events -->
            <div class="field-card" *ngIf="hasValue(caseData.events)">
              <div class="card-header">
                <i class="fa fa-calendar card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Key Events</h4>
              </div>
              <ul class="event-list">
                <li *ngFor="let e of caseData.events">
                  <span class="event-dot"></span>
                  <span class="event-date">{{ e.date }}</span>
                  <span class="event-label">{{ e.label }}</span>
                </li>
              </ul>
            </div>
             
            <!-- Deadlines -->
            <div class="field-card" *ngIf="hasValue(caseData.deadline)">
              <div class="card-header">
                <i class="fa-solid fa-clock" style="color:#0078D4" aria-hidden="true"></i>
                <h4 class="section-heading">Deadlines</h4>
              </div>
              <p class="field-value deadline-text"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ caseData.deadline }}</p>
            </div>

            <!-- Additional Information -->
            <div class="field-card" *ngIf="hasValue(caseData.additionalInformation)">
              <div class="card-header">
                <i class="fa fa-info-circle card-icon" aria-hidden="true"></i>
                <h4 class="section-heading">Additional Information</h4>
              </div>
              <p class="field-value" [class.clamp-text]="isLongText(caseData.additionalInformation) && !isFieldExpanded('additionalInformation')">{{ caseData.additionalInformation }}</p>
              <button type="button" class="read-more-btn" *ngIf="isLongText(caseData.additionalInformation)" (click)="toggleFieldExpanded('additionalInformation')">
                {{ isFieldExpanded('additionalInformation') ? 'Read less' : 'Read more' }}
                <i class="fa" [ngClass]="isFieldExpanded('additionalInformation') ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
              </button>
            </div>

          </div>
        </div>

        <!-- Supporting Documents tab -->
        <div class="tab-panel" *ngIf="activeTab === 'documents'">

          <div class="empty-state-container compact" *ngIf="documentCount === 0">
            <i class="fa fa-file-text-o empty-state-glyph" aria-hidden="true"></i>
            <p class="empty-state-title">No Supporting Documents</p>
            <p class="empty-state-subtitle">No documents have been shared for this case.</p>
          </div>

          <div class="doc-grid" *ngIf="documentCount > 0">
            <div class="doc-item" *ngFor="let doc of caseData.supportingDocuments">
              <div class="doc-icon-wrapper">
                <span class="doc-icon">
                  <!-- Single unified document glyph for every file — matches the
                       approved reference card; not derived from doc.fileType,
                       so no per-type color/icon variation. -->
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2H6Z" fill="#0078D4"/>
                    <path d="M14 2V7C14 7.55228 14.4477 8 15 8H20L14 2Z" fill="#5FACE3"/>
                    <rect x="7.5" y="10.2" width="5" height="1.6" rx="0.8" fill="#ffffff" opacity="0.9"/>
                    <rect x="7.5" y="13.4" width="9" height="1.6" rx="0.8" fill="#ffffff"/>
                    <rect x="7.5" y="16.6" width="9" height="1.6" rx="0.8" fill="#ffffff"/>
                  </svg>
                </span>
              </div>
              <div class="doc-info">
                <p class="doc-name" [title]="doc.name">{{ doc.name }}</p>
                <p class="doc-date" *ngIf="doc.uploadedOn">{{ doc.uploadedOn }}</p>
              </div>
              <div class="doc-actions">
                <button type="button" class="icon-btn" (click)="viewDocument(doc)"
                        [attr.aria-label]="'View ' + doc.name" [title]="'View ' + doc.name">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 5C6.5 5 2.7 8.5 1 12C2.7 15.5 6.5 19 12 19C17.5 19 21.3 15.5 23 12C21.3 8.5 17.5 5 12 5Z" fill="#0078D4"/>
                    <circle cx="12" cy="12" r="3.1" fill="#ffffff"/>
                  </svg>
                </button>
                <button type="button" class="icon-btn" (click)="downloadDocument(doc)"
                        [attr.aria-label]="'Download ' + doc.name" [title]="'Download ' + doc.name">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 3V15"/>
                    <path d="M7 10L12 15L17 10"/>
                    <path d="M4 19H20"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes tab -->
        <div class="tab-panel" *ngIf="activeTab === 'notes'">

          <div class="loading-state compact" *ngIf="notesLoading">
            <p class="loading-text">Loading notes…</p>
          </div>

          <div class="empty-state-container compact" *ngIf="!notesLoading && notes.length === 0">
            <i class="fa fa-sticky-note-o empty-state-glyph" aria-hidden="true"></i>
            <p class="empty-state-title">No Notes Added</p>
            <p class="empty-state-subtitle">Add a note to keep track of important information about this case.</p>
            <button type="button" class="btn-add-notes" (click)="openAddNotes()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add Notes
            </button>
          </div>

          <div class="notes-grid" *ngIf="!notesLoading && notes.length > 0">
            <div class="note-card" *ngFor="let note of notes">
              <div class="note-card-top">
                <p class="note-content">{{ note.content }}</p>
                <button mat-icon-button class="note-menu-btn" [matMenuTriggerFor]="noteMenu" aria-label="Note actions">
                  <span class="kebab-icon" aria-hidden="true"><span></span><span></span><span></span></span>
                </button>
                <mat-menu #noteMenu="matMenu" class="custom-mat-menu" xPosition="before">
                  <button mat-menu-item (click)="openEditNote(note)" [disabled]="!note.hasPersistedId"
                          [title]="!note.hasPersistedId ? 'Unavailable — this note is missing an identifier from the server' : ''">
                    <span class="menu-item-icon menu-item-icon--edit"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    Edit Note
                  </button>
                  <!-- <button mat-menu-item (click)="openShareNote(note)">
                    <span class="menu-item-icon"><i class="fa fa-share-alt" aria-hidden="true"></i></span>
                    Share Note
                  </button> -->
                  <div class="menu-divider"></div>
                  <button mat-menu-item class="menu-item--danger" (click)="openDeleteNote(note)" [disabled]="!note.hasPersistedId"
                          [title]="!note.hasPersistedId ? 'Unavailable — this note is missing an identifier from the server' : ''">
                    <span class="menu-item-icon menu-item-icon--danger"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                    Delete Note
                  </button>
                </mat-menu>
              </div>
              <button type="button" class="read-more-btn note-read-more" *ngIf="isNoteLong(note.content)" (click)="openViewNote(note)">
                Read more <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </button>
              <p class="note-meta"> 
                <i class="fa fa-calendar-o" aria-hidden="true"></i>
                {{ (note.createdAt + 'Z') | date:'MMM d, yyyy':'Asia/Kolkata' }}
                &middot;
                {{ (note.createdAt + 'Z') | date:'h:mm a':'Asia/Kolkata' }}
                <!-- <i class="fa fa-calendar-o" aria-hidden="true"></i> {{ note.createdAt | date:'MMM d, y' }} &middot; {{ note.createdAt | date:'h:mm a' }} -->
                <!-- <ng-container *ngIf="note.author"> &middot; <i class="fa fa-user" aria-hidden="true"></i> Added by {{ note.author }}</ng-container> -->
                <!-- <span class="shared-tag" *ngIf="note.shared"><i class="fa fa-share" aria-hidden="true"></i> Shared</span> -->
              </p>
            </div>
          </div>
        </div>

      </ng-container>

      <div class="empty-state-container" *ngIf="!loading && !caseData">
        <i class="fa fa-exclamation-circle empty-state-glyph" aria-hidden="true"></i>
        <p class="empty-state-title">This case could not be found.</p>
      </div>

    </div>
  </div>
</div>